import React, { useState } from 'react';
import { contextSelectorActions } from '@klp/contextSelector/store/contextSelectorSlice';
import { Heading } from '@klp/design/Heading';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { Tooltip } from '@klp/design/Tooltip';
import type { Theme } from '@material-ui/core';
import {
    IconButton,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ByggSelectorSettingsDialog } from './ByggSelectorSettingsDialog';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import classNames from 'classnames';

const styles = (theme: Theme) => ({
    byggSelectorHeader: {
        borderBottom: '1px solid transparent',
        borderBottomColor: theme.palette.secondary.main,
    },
});

export const ByggSelectorHeader = () => {
    const { t } = useTranslation();
    const classes = useKlpStyles({}, styles);
    const [dialogOpen, setDialogOpen] = useState(false);

    const dispatch = useDispatch();
    const { setAndResetSelectorFocus } = contextSelectorActions;

    const handleFocusContextSelector = () => {
        dispatch(setAndResetSelectorFocus());
    };

    const toggleDialogOpen = () => {
        setDialogOpen(!dialogOpen);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <ListItem
            disableGutters={true}
            className={classNames(
                'ByggSelector__ListItem',
                classes.byggSelectorHeader,
            )}
        >
            <ListItemIcon>
                <Tooltip title={t('general.contextSelectorHint')}>
                    <IconButton
                        onClick={handleFocusContextSelector}
                        size="medium"
                    >
                        <Illustration
                            icon={IconName.PLUS}
                            size="small"
                            klpPalette="secondary"
                        />
                    </IconButton>
                </Tooltip>
            </ListItemIcon>
            <ListItemText
                primary={
                    <Heading
                        klpHeadingLevel="THREE"
                        translation="bygg.myBuildings"
                    />
                }
            />
            <IconButton onClick={toggleDialogOpen}>
                <Illustration icon={IconName.GEAR} size="small" />
            </IconButton>
            <ByggSelectorSettingsDialog
                open={dialogOpen}
                onClose={handleDialogClose}
            />
        </ListItem>
    );
};
